export default function BarcodePreview({ previewUrl, alt, format }) {
    if (!previewUrl) return null;

    if (format === 'svg') {
        return (
            <div className="flex h-full min-h-0 flex-1 items-center justify-center p-6">
                <object
                    data={previewUrl}
                    type="image/svg+xml"
                    aria-label={alt}
                    className="max-h-full max-w-full"
                />
            </div>
        );
    }

    return (
        <div className="flex h-full min-h-0 flex-1 items-center justify-center p-6">
            <img
                src={previewUrl}
                alt={alt}
                className="max-h-full max-w-full rounded-xl bg-white p-4 shadow-sm dark:bg-zinc-900"
                draggable={false}
            />
        </div>
    );
}
